// extracted by mini-css-extract-plugin
export default {"header":"header___zJ8FC","privacy":"privacy___VchEg","updated":"updated___sI9aQ"};